import { toQuery, type HttpClient } from '../client';
import type { PageResult } from '../types/result';
import type {
  SupplierDeliveryRow,
  TrackQuery,
  TrackReportRequest,
  TrackReportResult,
  TrackRow
} from '../types/track';

const BASE = '/wl/track';

/** 配送轨迹（Hq.Api Tracking）：只读时间轴 + 节点回传（PICK/PACK/SHIP/ARRIVE/EXCEPTION）。 */
export function createTrackApi(http: HttpClient) {
  return {
    list(query: TrackQuery = {}): Promise<PageResult<TrackRow>> {
      return http.request<PageResult<TrackRow>>({ path: BASE, query: toQuery(query) });
    },

    /** 回传节点：需 `wl:delivery:manage` 或 `wl:inventory:manage`（PDA/移动端回传用）；供应商门户限 SHIP/ARRIVE/EXCEPTION。 */
    report(body: TrackReportRequest): Promise<TrackReportResult> {
      return http.request<TrackReportResult>({ path: BASE, method: 'POST', body });
    },

    /** 供应商自发货：本主体名下的配送单（`delivery_mode=SELF` 时用于回传运输节点）。 */
    supplierDeliveries(): Promise<SupplierDeliveryRow[]> {
      return http.request<SupplierDeliveryRow[]>({ path: `${BASE}/deliveries` });
    }
  };
}

export type TrackApi = ReturnType<typeof createTrackApi>;
